import { render, staticRenderFns } from "./r-ticket-table.vue?vue&type=template&id=1837323b"
import script from "./r-ticket-table.vue?vue&type=script&lang=js"
export * from "./r-ticket-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1837323b')) {
      api.createRecord('1837323b', component.options)
    } else {
      api.reload('1837323b', component.options)
    }
    module.hot.accept("./r-ticket-table.vue?vue&type=template&id=1837323b", function () {
      api.rerender('1837323b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency/r-ticket-table.vue"
export default component.exports